import { FormattedMessage } from 'react-intl';
import NotificationRequestAccepted from '../../img/NotificationRequestAccepted.svg';
import NotificationRequestRejected from '../../img/NotificationRequestRejected.svg';
import './Notifications.css';

const RequestActionLabels = ({ requestStatus }) => {
  return (
    <>
      {requestStatus === 'accepted' && (
        <div style={{ color: 'var(--text)' }}>
          <img
            loading="lazy"
            src={NotificationRequestAccepted}
            alt="accepted"
            style={{ marginRight: '8px' }}
          />
          <FormattedMessage id="accepted" defaultMessage="Accepted" />
        </div>
      )}

      {requestStatus === 'rejected' && (
        <div style={{ color: 'var(--text)' }}>
          <img
            loading="lazy"
            src={NotificationRequestRejected}
            alt="rejected"
            style={{ marginRight: '8px' }}
          />
          <FormattedMessage id="rejected" defaultMessage="Rejected" />
        </div>
      )}
    </>
  );
};

export default RequestActionLabels;
